/*
  Saved reports: "Open" shows the report on the screen
  (GET /api/reports/{id}/generate).
  Merged FIRST into TRANSLATION_MAPS in ./index.js. Keys are the English source.
*/

const ru = {
  "Open report": "Открыть",
  "Report": "Отчёт",
  "Period {start} — {end}, time zone {tz}, currency {currency}.": "Период {start} — {end}, часовой пояс {tz}, валюта {currency}.",
  "The same data as in the CSV and XLSX downloads.": "Те же данные, что в выгрузках CSV и XLSX.",
  "Building the report…": "Строим отчёт…",
  "Could not build the report.": "Не удалось построить отчёт.",
  "Try loading again": "Загрузить ещё раз",
  "No data for this period.": "За этот период данных нет.",
  "Exchange rates were not available: amounts in other currencies are not converted.": "Курсы валют были недоступны: суммы в других валютах не пересчитаны.",
  "Status: {status}": "Статус: {status}",
  "Report date": "Дата",
  "Report campaign": "Кампания",
  "Report stage": "Этап",
  "Report clicks": "Клики",
  "Report unique clicks": "Уникальные клики",
  "Report conversions": "Конверсии",
  "Report revenue": "Доход",
  "Report cost": "Расход",
  "Report profit": "Прибыль",
  "Reusable report definitions you can open on the screen or export to CSV or XLSX.": "Сохранённые отчёты: откройте на экране или выгрузите в CSV или XLSX.",
};

const es = {
  "Open report": "Abrir",
  "Report": "Informe",
  "Period {start} — {end}, time zone {tz}, currency {currency}.": "Periodo {start} — {end}, zona horaria {tz}, moneda {currency}.",
  "The same data as in the CSV and XLSX downloads.": "Los mismos datos que en las descargas CSV y XLSX.",
  "Building the report…": "Generando el informe…",
  "Could not build the report.": "No se pudo generar el informe.",
  "Try loading again": "Volver a cargar",
  "No data for this period.": "No hay datos para este periodo.",
  "Exchange rates were not available: amounts in other currencies are not converted.": "Los tipos de cambio no estaban disponibles: los importes en otras monedas no se convirtieron.",
  "Status: {status}": "Estado: {status}",
  "Report date": "Fecha",
  "Report campaign": "Campaña",
  "Report stage": "Etapa",
  "Report clicks": "Clics",
  "Report unique clicks": "Clics únicos",
  "Report conversions": "Conversiones",
  "Report revenue": "Ingresos",
  "Report cost": "Coste",
  "Report profit": "Beneficio",
  "Reusable report definitions you can open on the screen or export to CSV or XLSX.": "Informes guardados: ábrelos en pantalla o expórtalos a CSV o XLSX.",
};

const pt = {
  "Open report": "Abrir",
  "Report": "Relatório",
  "Period {start} — {end}, time zone {tz}, currency {currency}.": "Período {start} — {end}, fuso horário {tz}, moeda {currency}.",
  "The same data as in the CSV and XLSX downloads.": "Os mesmos dados dos downloads CSV e XLSX.",
  "Building the report…": "Gerando o relatório…",
  "Could not build the report.": "Não foi possível gerar o relatório.",
  "Try loading again": "Carregar de novo",
  "No data for this period.": "Não há dados para este período.",
  "Exchange rates were not available: amounts in other currencies are not converted.": "As taxas de câmbio não estavam disponíveis: valores em outras moedas não foram convertidos.",
  "Status: {status}": "Status: {status}",
  "Report date": "Data",
  "Report campaign": "Campanha",
  "Report stage": "Etapa",
  "Report clicks": "Cliques",
  "Report unique clicks": "Cliques únicos",
  "Report conversions": "Conversões",
  "Report revenue": "Receita",
  "Report cost": "Custo",
  "Report profit": "Lucro",
  "Reusable report definitions you can open on the screen or export to CSV or XLSX.": "Relatórios salvos: abra na tela ou exporte para CSV ou XLSX.",
};

const de = {
  "Open report": "Öffnen",
  "Report": "Bericht",
  "Period {start} — {end}, time zone {tz}, currency {currency}.": "Zeitraum {start} — {end}, Zeitzone {tz}, Währung {currency}.",
  "The same data as in the CSV and XLSX downloads.": "Dieselben Daten wie in den CSV- und XLSX-Downloads.",
  "Building the report…": "Bericht wird erstellt…",
  "Could not build the report.": "Der Bericht konnte nicht erstellt werden.",
  "Try loading again": "Erneut laden",
  "No data for this period.": "Für diesen Zeitraum gibt es keine Daten.",
  "Exchange rates were not available: amounts in other currencies are not converted.": "Wechselkurse waren nicht verfügbar: Beträge in anderen Währungen sind nicht umgerechnet.",
  "Status: {status}": "Status: {status}",
  "Report date": "Datum",
  "Report campaign": "Kampagne",
  "Report stage": "Stufe",
  "Report clicks": "Klicks",
  "Report unique clicks": "Eindeutige Klicks",
  "Report conversions": "Conversions",
  "Report revenue": "Umsatz",
  "Report cost": "Kosten",
  "Report profit": "Gewinn",
  "Reusable report definitions you can open on the screen or export to CSV or XLSX.": "Gespeicherte Berichte: auf dem Bildschirm öffnen oder als CSV oder XLSX exportieren.",
};

const fr = {
  "Open report": "Ouvrir",
  "Report": "Rapport",
  "Period {start} — {end}, time zone {tz}, currency {currency}.": "Période {start} — {end}, fuseau horaire {tz}, devise {currency}.",
  "The same data as in the CSV and XLSX downloads.": "Les mêmes données que dans les téléchargements CSV et XLSX.",
  "Building the report…": "Création du rapport…",
  "Could not build the report.": "Impossible de créer le rapport.",
  "Try loading again": "Recharger",
  "No data for this period.": "Aucune donnée pour cette période.",
  "Exchange rates were not available: amounts in other currencies are not converted.": "Les taux de change n’étaient pas disponibles : les montants dans d’autres devises ne sont pas convertis.",
  "Status: {status}": "Statut : {status}",
  "Report date": "Date",
  "Report campaign": "Campagne",
  "Report stage": "Étape",
  "Report clicks": "Clics",
  "Report unique clicks": "Clics uniques",
  "Report conversions": "Conversions",
  "Report revenue": "Revenus",
  "Report cost": "Coût",
  "Report profit": "Bénéfice",
  "Reusable report definitions you can open on the screen or export to CSV or XLSX.": "Rapports enregistrés : ouvrez-les à l’écran ou exportez-les en CSV ou XLSX.",
};

const it = {
  "Open report": "Apri",
  "Report": "Report",
  "Period {start} — {end}, time zone {tz}, currency {currency}.": "Periodo {start} — {end}, fuso orario {tz}, valuta {currency}.",
  "The same data as in the CSV and XLSX downloads.": "Gli stessi dati dei download CSV e XLSX.",
  "Building the report…": "Creazione del report…",
  "Could not build the report.": "Impossibile creare il report.",
  "Try loading again": "Ricarica",
  "No data for this period.": "Nessun dato per questo periodo.",
  "Exchange rates were not available: amounts in other currencies are not converted.": "I tassi di cambio non erano disponibili: gli importi in altre valute non sono convertiti.",
  "Status: {status}": "Stato: {status}",
  "Report date": "Data",
  "Report campaign": "Campagna",
  "Report stage": "Fase",
  "Report clicks": "Clic",
  "Report unique clicks": "Clic unici",
  "Report conversions": "Conversioni",
  "Report revenue": "Ricavi",
  "Report cost": "Costo",
  "Report profit": "Profitto",
  "Reusable report definitions you can open on the screen or export to CSV or XLSX.": "Report salvati: aprili sullo schermo o esportali in CSV o XLSX.",
};

const pl = {
  "Open report": "Otwórz",
  "Report": "Raport",
  "Period {start} — {end}, time zone {tz}, currency {currency}.": "Okres {start} — {end}, strefa czasowa {tz}, waluta {currency}.",
  "The same data as in the CSV and XLSX downloads.": "Te same dane co w plikach CSV i XLSX.",
  "Building the report…": "Tworzenie raportu…",
  "Could not build the report.": "Nie udało się utworzyć raportu.",
  "Try loading again": "Wczytaj ponownie",
  "No data for this period.": "Brak danych za ten okres.",
  "Exchange rates were not available: amounts in other currencies are not converted.": "Kursy walut były niedostępne: kwoty w innych walutach nie zostały przeliczone.",
  "Status: {status}": "Status: {status}",
  "Report date": "Data",
  "Report campaign": "Kampania",
  "Report stage": "Etap",
  "Report clicks": "Kliknięcia",
  "Report unique clicks": "Unikalne kliknięcia",
  "Report conversions": "Konwersje",
  "Report revenue": "Przychód",
  "Report cost": "Koszt",
  "Report profit": "Zysk",
  "Reusable report definitions you can open on the screen or export to CSV or XLSX.": "Zapisane raporty: otwórz na ekranie albo wyeksportuj do CSV lub XLSX.",
};

const tr = {
  "Open report": "Aç",
  "Report": "Rapor",
  "Period {start} — {end}, time zone {tz}, currency {currency}.": "Dönem {start} — {end}, saat dilimi {tz}, para birimi {currency}.",
  "The same data as in the CSV and XLSX downloads.": "CSV ve XLSX indirmeleriyle aynı veriler.",
  "Building the report…": "Rapor oluşturuluyor…",
  "Could not build the report.": "Rapor oluşturulamadı.",
  "Try loading again": "Tekrar yükle",
  "No data for this period.": "Bu dönem için veri yok.",
  "Exchange rates were not available: amounts in other currencies are not converted.": "Döviz kurları kullanılamadı: diğer para birimlerindeki tutarlar çevrilmedi.",
  "Status: {status}": "Durum: {status}",
  "Report date": "Tarih",
  "Report campaign": "Kampanya",
  "Report stage": "Aşama",
  "Report clicks": "Tıklamalar",
  "Report unique clicks": "Tekil tıklamalar",
  "Report conversions": "Dönüşümler",
  "Report revenue": "Gelir",
  "Report cost": "Maliyet",
  "Report profit": "Kâr",
  "Reusable report definitions you can open on the screen or export to CSV or XLSX.": "Kayıtlı raporlar: ekranda açın veya CSV ya da XLSX olarak dışa aktarın.",
};

const uk = {
  "Open report": "Відкрити",
  "Report": "Звіт",
  "Period {start} — {end}, time zone {tz}, currency {currency}.": "Період {start} — {end}, часовий пояс {tz}, валюта {currency}.",
  "The same data as in the CSV and XLSX downloads.": "Ті самі дані, що й у вивантаженнях CSV і XLSX.",
  "Building the report…": "Будуємо звіт…",
  "Could not build the report.": "Не вдалося побудувати звіт.",
  "Try loading again": "Завантажити ще раз",
  "No data for this period.": "За цей період даних немає.",
  "Exchange rates were not available: amounts in other currencies are not converted.": "Курси валют були недоступні: суми в інших валютах не перераховано.",
  "Status: {status}": "Статус: {status}",
  "Report date": "Дата",
  "Report campaign": "Кампанія",
  "Report stage": "Етап",
  "Report clicks": "Кліки",
  "Report unique clicks": "Унікальні кліки",
  "Report conversions": "Конверсії",
  "Report revenue": "Дохід",
  "Report cost": "Витрати",
  "Report profit": "Прибуток",
  "Reusable report definitions you can open on the screen or export to CSV or XLSX.": "Збережені звіти: відкрийте на екрані або вивантажте в CSV чи XLSX.",
};

const SAVED_REPORT_VIEW = { ru, es, pt, de, fr, it, pl, tr, uk };
export default SAVED_REPORT_VIEW;
